import useSettingsStore from '@/store/SettingsStore';
import styled from 'styled-components';

const LoadingDots = () => {

  const theme = useSettingsStore(state => state.theme);

  const StyledWrapper = styled.div`
  .loader {
    width: 40px;
    display: flex;
    justify-content: space-evenly;
  }

  .ball {
    list-style: none;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${theme === "light" ? "#000" : "#fff"};
  }

  .ball:nth-child(1) {
    animation: bounce-1 1s ease-in-out infinite;
  }

  @keyframes bounce-1 {
    50% {
      transform: translateY(-4px);
    }
  }

  .ball:nth-child(2) {
    animation: bounce-3 1s ease-in-out 0.3s infinite;
  }

  @keyframes bounce-2 {
    50% {
      transform: translateY(-4px);
    }
  }

  .ball:nth-child(3) {
    animation: bounce-3 1s ease-in-out 0.6s infinite;
  }

  @keyframes bounce-3 {
    50% {
      transform: translateY(-4px);
    }
  }`;

  return (
    <StyledWrapper>
      <div className="loader">
        <li className="ball" />
        <li className="ball" />
        <li className="ball" />
      </div>
    </StyledWrapper>
  );
}

export default LoadingDots